import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPlugConnected = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	width: 20,
	height: 20,
	strokeWidth: 1.5,
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", { d: "M7 12l5 5l-1.5 1.5a3.536 3.536 0 1 1 -5 -5l1.5 -1.5z" }),
		/* @__PURE__ */ _jsx("path", { d: "M17 12l-5 -5l1.5 -1.5a3.536 3.536 0 1 1 5 5l-1.5 1.5z" }),
		/* @__PURE__ */ _jsx("path", { d: "M3 21l2.5 -2.5" }),
		/* @__PURE__ */ _jsx("path", { d: "M18.5 5.5l2.5 -2.5" }),
		/* @__PURE__ */ _jsx("path", { d: "M10 11l-2 2" }),
		/* @__PURE__ */ _jsx("path", { d: "M13 14l-2 2" })
	]
});
const ForwardRef = forwardRef(SvgPlugConnected);
export default ForwardRef;
